import { Factory } from 'miragejs';

export default Factory.extend({
  granted_scopes: 'offline_access organization.read attachment.write',
  granted_at: i => new Date(Date.now() - 24 * 60 * 60 * 1000 * (164 + i)).toISOString(), //This is 165 (166, 167...) days ago. consents are valid for 180 days.
  expires_at: i => new Date(Date.now() + 24 * 60 * 60 * 1000 * (16 - i)).toISOString(), // This is in 15 (14, 13...) days.
});
